const LOG_PREFIX = '[AuthDebug]';

/** Set to false to silence [AuthDebug] logs. */
export const AUTH_DEBUG_LOGGING_ENABLED = true;

const timers = new Map<string, number>();
let syncSessionCounter = 0;

function elapsedSinceStartMs(): number {
  if (typeof performance === 'undefined') {
    return 0;
  }
  return Math.round(performance.now());
}

export function logAuth(phase: string, detail?: Record<string, unknown>): void {
  if (!AUTH_DEBUG_LOGGING_ENABLED) {
    return;
  }

  const payload = detail ? ` ${JSON.stringify(detail)}` : '';
  console.log(`${LOG_PREFIX} ${phase}${payload}`);
}

export function startAuthTimer(label: string): void {
  if (!AUTH_DEBUG_LOGGING_ENABLED) {
    return;
  }
  timers.set(label, performance.now());
}

export function endAuthTimer(
  label: string,
  detail?: Record<string, unknown>,
): void {
  if (!AUTH_DEBUG_LOGGING_ENABLED) {
    return;
  }

  const startedAt = timers.get(label);
  const durationMs =
    startedAt !== undefined
      ? Math.round(performance.now() - startedAt)
      : undefined;
  timers.delete(label);
  logAuth(label, { ...detail, durationMs });
}

export function beginSyncSession(
  uid: string,
  mode: 'blocking' | 'background',
): number {
  syncSessionCounter += 1;
  const sessionId = syncSessionCounter;
  logAuth('sync:start', { sessionId, uid, mode });
  return sessionId;
}

export function logSyncStep(
  sessionId: number,
  step: string,
  detail?: Record<string, unknown>,
): void {
  logAuth(`sync:${step}`, { sessionId, ...detail });
}

export function endSyncSession(
  sessionId: number,
  outcome: 'success' | 'error',
  detail?: Record<string, unknown>,
): void {
  endAuthTimer(`sync:${sessionId}`, { sessionId, outcome, ...detail });
}

export function logLoginUserStatusChange(
  from: string | undefined,
  to: string,
  reason: string,
  detail?: Record<string, unknown>,
): void {
  logAuth('loginUserStatus', {
    from,
    to,
    reason,
    elapsedMs: elapsedSinceStartMs(),
    ...detail,
  });
}
